export default "__VITE_ASSET__BHTNAYai__"